import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import PropTypes from 'prop-types';

import Loader from 'components/Loader';
import { APPLICATION_VERSION } from 'constants/appVersion.constant';
import { useThunkSelector } from 'utility/redux';
import showFeature from 'utility/showFeature';
import loadAppDynamics from './appdynamics';
import { loginRequest } from '../../entraConfig';

function RequireAuth({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress, accounts } = useMsal();

  const moduleAccess = useThunkSelector('moduleAccess');

  const getUserEmail = async () => {
    if (accounts.length > 0) {
      return accounts[0].username;
    }
    return null;
  };

  const setAppDynamicsUserProperty = async () => {
    const userEmail = await getUserEmail();
    if (userEmail) {
      loadAppDynamics(userEmail);
    }
  };

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }

    if (isAuthenticated) {
      const allAccounts = instance.getAllAccounts();
      if (allAccounts.length > 0) {
        instance.setActiveAccount(allAccounts[0]);
      }
    }

    if (
      moduleAccess.isSuccess &&
      showFeature([APPLICATION_VERSION.ENV.TEST, APPLICATION_VERSION.ENV.PROD])
    ) {
      setAppDynamicsUserProperty();
    }
  }, [isAuthenticated, inProgress, instance, moduleAccess, accounts]);

  if (!isAuthenticated || inProgress !== InteractionStatus.None) {
    return (
      <div className="row" data-testid="auth-loader">
        <div className="col-12 d-flex flex-column p-5 m-5">
          <Loader loadingMessage="Authenticating" />
        </div>
      </div>
    );
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RequireAuth;
